import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { emailValido, obrigatorio } from '@/shareds/regras'
import { AcessoParcial } from 'common/types/Login'
import { associarEmail } from '@/services/AuthService'
import { alert, authModule } from '@/store'
import { auth } from '@/firebase'
import { useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssociarEmail',
  props: {
	usuario: { type: Object as PropType<Pick<AcessoParcial, 'nomeCompleto' | 'email'>>, required: true },
},
  setup(__props) {

const props = __props;



const router = useRouter()

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const carregando = ref(false)
const editando = ref(false)
const verSenha = ref(false)
const email = ref(authModule.emailPendente ?? props.usuario.email ?? '')
const senha = ref('')

async function enviar() {
	if (!form.value!.validate()) return
	try {
		carregando.value = true
		const { data } = await associarEmail({
			email: email.value.trim(),
			senha: senha.value,
		})
		// antes do logarToken, que troca a sessão do Firebase pela anônima
		const confirmacaoEnviada = await enviarConfirmacao(data.emailPendente!, senha.value)
		await authModule.logarToken(data)
		editando.value = false
		senha.value = ''
		if (!confirmacaoEnviada)
			alert.setError('Não foi possível enviar o e-mail de confirmação. Use "Reenviar ou trocar e-mail".')
	} catch (error) {
		alert.setError(error)
	} finally {
		carregando.value = false
	}
}

/** o Firebase só envia a confirmação na sessão do próprio usuário, então o app entra com a senha que acabou de ser conferida */
async function enviarConfirmacao(emailAssociado: string, senhaAtual: string) {
	try {
		auth.languageCode = 'pt_BR'
		const { user } = await auth.signInWithEmailAndPassword(emailAssociado, senhaAtual)
		await user!.sendEmailVerification()
		return true
	} catch (error) {
		console.error(error)
		return false
	}
}

function continuar() {
	router.push({ name: 'home' })
		.catch(() => {})
}

return { __sfc: true,props, router, form, carregando, editando, verSenha, email, senha, enviar, enviarConfirmacao, continuar, ContainerCenter, emailValido, obrigatorio, authModule }
}

})